export default __webpack_public_path__ + "static/media/light-fantom.2b292f77.png";